import {call, put, all, takeLatest, select, takeEvery, delay} from "redux-saga/effects";

import {
  changeSelectedSpecialityPriorityAction,
  changeSelectedSpecialityPriorityActionDone,
  changeSelectedSpecialityPriorityActionFail,
  createEducationOrderAction,
  createEducationOrderActionDone,
  createEducationOrderActionFail,
  createSelectedSpecialityAction,
  createSelectedSpecialityActionDone,
  createSelectedSpecialityActionFail,
  deleteSelectedSpecialityAction,
  deleteSelectedSpecialityActionDone,
  deleteSelectedSpecialityActionFail,
  editEntrantStatusAction,
  editEntrantStatusActionDone,
  editEntrantStatusActionFail,
  educationDocumentRatingAction,
  educationDocumentRatingActionDone,
  educationDocumentRatingActionFail,
  fetchAddLessonProfileAction,
  fetchAddLessonProfileActionDone,
  fetchAddLessonProfileActionFail,
  fetchAddLessonProfileNewAction,
  fetchAddLessonProfileNewActionDone,
  fetchAddLessonProfileNewActionFail,
  fetchAddToStudentList,
  fetchAddToStudentListDone,
  fetchAddToStudentListFail,
  fetchAdmissionLog,
  fetchAdmissionLogDone,
  fetchAdmissionLogFail,
  fetchCheckEmailAction,
  fetchCheckEmailActionDone,
  fetchCheckEmailActionFail,
  fetchCheckIinAction,
  fetchCheckIinActionDone,
  fetchCheckIinActionFail,
  fetchCollegeAndExecutorAction,
  fetchCollegeAndExecutorActionDone,
  fetchCollegeAndExecutorActionFail,
  fetchCollegeListToTransferAction,
  fetchCollegeListToTransferActionDone,
  fetchCollegeListToTransferActionFail,
  fetchCollegesWithQualificationsAction,
  fetchCollegesWithQualificationsActionDone,
  fetchCollegesWithQualificationsActionFail,
  fetchCreateAdmissionDocumentAction,
  fetchCreateAdmissionDocumentActionDone,
  fetchCreateAdmissionDocumentActionFail,
  fetchDataForSpecialitiesFormAction,
  fetchDataForSpecialitiesFormActionDone,
  fetchDataForSpecialitiesFormActionFail,
  fetchDeclineReason,
  fetchDeclineReasonDone,
  fetchDeclineReasonFail,
  fetchDeleteLessonAction,
  fetchDeleteLessonActionDone,
  fetchDeleteLessonActionFail,
  fetchDeleteProfileNewLessonAction,
  fetchDeleteProfileNewLessonActionDone,
  fetchDeleteProfileNewLessonActionFail,
  fetchEditLessonAction,
  fetchEditLessonActionDone,
  fetchEditLessonActionFail,
  fetchEditNewProfileLessonAction,
  fetchEditNewProfileLessonActionDone,
  fetchEditNewProfileLessonActionFail,
  fetchEducationEditOrderAction,
  fetchEducationEditOrderActionDone,
  fetchEducationEditOrderActionFail,
  fetchEducationOrderXMLAction,
  fetchEducationOrderXMLActionDone,
  fetchEducationOrderXMLActionFail,
  fetchEntrantApplicationsAction,
  fetchEntrantApplicationsActionDone,
  fetchEntrantApplicationsActionFail,
  fetchEntrantInfoAction,
  fetchEntrantInfoActionDone,
  fetchEntrantInfoActionFail,
  fetchEntrantTransferToOtherCollegeAction,
  fetchEntrantTransferToOtherCollegeActionDone,
  fetchEntrantTransferToOtherCollegeActionFail,
  fetchExamResultAction,
  fetchExamResultActionDone,
  fetchExamResultActionFail,
  fetchExecutorEgovApplication,
  fetchExecutorEgovApplicationDone,
  fetchExecutorEgovApplicationFail,
  fetchGeneralContestActionDone,
  fetchGeneralContestSpecialitiesListAction,
  fetchGeneralContestSpecialitiesListActionDone,
  fetchGeneralContestSpecialitiesListActionFail,
  fetchGeneralContestWithQuotesAction,
  fetchGeneralContestWithQuotesActionDone,
  fetchGeneralContestWithQuotesActionFail,
  fetchGetInfoAction,
  fetchGetInfoActionDone,
  fetchGetInfoActionFail,
  fetchGetMarksAction,
  fetchGetMarksActionDone,
  fetchGetMarksActionFail,
  fetchGetStudentByEducationOrder,
  fetchGetStudentByEducationOrderDone,
  fetchGetStudentByEducationOrderFail,
  fetchGetTotalResultAction,
  fetchGetTotalResultActionDone,
  fetchGetTotalResultActionFail,
  fetchGroupListAction,
  fetchGroupListActionDone,
  fetchGroupListActionFail,
  fetchLanguagesForSpecialitiesFormAction,
  fetchLanguagesForSpecialitiesFormActionDone,
  fetchLanguagesForSpecialitiesFormActionFail,
  fetchOrderCreate,
  fetchOrderCreateDone,
  fetchOrderCreateFail,
  fetchOrderEdit,
  fetchOrderEditDone,
  fetchOrderEditFail, fetchOrderLeaveStudent, fetchOrderLeaveStudentDone, fetchOrderLeaveStudentFail,
  fetchOrderView,
  fetchOrderViewDone,
  fetchOrderViewFail,
  fetchProvincesAction,
  fetchProvincesActionDone,
  fetchProvincesActionFail,
  fetchSetExamMarkAction,
  fetchSetExamMarkActionDone,
  fetchSetExamMarkActionFail,
  fetchSetExamResultAction,
  fetchSetExamResultActionDone,
  fetchSetExamResultActionFail,
  fetchSetSpecialityStatusAction,
  fetchSetSpecialityStatusActionDone,
  fetchSetSpecialityStatusActionFail,
  fetchSetStatusAction,
  fetchSetStatusActionDone,
  fetchSetStatusActionFail,
  postEducationOrderXMLAction,
  postEducationOrderXMLActionDone,
  postEducationOrderXMLActionFail
} from "./actions";
import {
  addDocument,
  addLessonProfile,
  addToStudentListApi,
  admissionLogApi,
  changeEntrantResponse,
  changeSelectedSpecialityPriority, checkEmail,
  checkIIN,
  createEducationOrder,
  createSelectedSpeciality,
  declineReason,
  deleteLesson,
  deleteSelectedSpeciality,
  editLesson,
  educationDocumentRating, entrantTransferToOtherCollege,
  fetchChangeEducationOrder,
  fetchCollegeAndExecutor, fetchCollegesWithQualification,
  fetchDataForSpecialitiesFormV2,
  fetchExamResult,
  fetchGroupList,
  fetchLanguagesForSpecialitiesForm,
  fetchProvinces,
  getCollegeListToTransfer, getEducationOrderXML,
  getEntrantApplications, getEntrantInfoData,
  getGeneralContestSpecialitiesList,
  getGeneralContestWithQuotesNew,
  getInfo,
  getMarks,
  getStudentIdByEducationOrder,
  getTotalResult, leaveStudentApi,
  orderCreateApi,
  orderEditApi,
  orderViewApi, postEducationOrderXML,
  setExamResult,
  setExecutorEgovApplication,
  setSpecialtyStatus,
  setStatus
} from "./api";
import {message} from "antd";


function* createEducationOrderFlow({ payload }:any):any{
  try {
    const data = yield call(createEducationOrder, payload)
    if (data) {
      yield put(createEducationOrderActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(createEducationOrderActionFail())
  }
}

function* fetchChangeEducationOrderFlow({ payload }:any):any{
  try {
    const data = yield call(fetchChangeEducationOrder, payload)
    if (data) {
      yield put(fetchEducationEditOrderActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    message.error({
      // @ts-ignore
      content: e, style: {
        marginTop: '50vh'
      }
    })
    yield put(fetchEducationEditOrderActionFail())
  }
}

function* fetchDataForSpecialitiesFormV2Flow({ payload }:any):any{
  try {
    const data = yield call(fetchDataForSpecialitiesFormV2, payload)
    if (data) {
      yield put(fetchDataForSpecialitiesFormActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchDataForSpecialitiesFormActionFail())
  }
}

function* fetchCollegesWithQualificationsFlow({ payload }:any):any{
  try {
    const data = yield call(fetchCollegesWithQualification, payload)
    if (data) {
      yield put(fetchCollegesWithQualificationsActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchCollegesWithQualificationsActionFail())
  }
}

function* createSelectedSpecialityFlow({ payload }:any):any{
  try {
    const data = yield call(createSelectedSpeciality, payload)
    if (data.data.data.addSelectedSpeciality) {
      yield put(createSelectedSpecialityActionDone(data.data.data.addSelectedSpeciality))
    } else {
      message.error({
        content: data.data.errors[0].debugMessage, style: {
          marginTop: '50vh'
        }
      })
    }
  } catch (e) {
    console.warn(e);
    yield put(createSelectedSpecialityActionFail())
  }
}

function* changeSelectedSpecialityPriorityFlow({ payload }:any):any{
  try {
    const data = yield call(changeSelectedSpecialityPriority, payload)
    if (data) {
      yield put(changeSelectedSpecialityPriorityActionDone(data))
    }
  } catch (e) {
    console.warn(e);
    yield put(changeSelectedSpecialityPriorityActionFail())
  }
}

function* deleteSelectedSpecialityFlow({ payload }:any):any{
  try {
    const data = yield call(deleteSelectedSpeciality, payload.id)
    if (data) {
      yield put(deleteSelectedSpecialityActionDone(data))
    }
  } catch (e) {
    console.warn(e);
    yield put(deleteSelectedSpecialityActionFail())
  }
}

function* fetchProvincesFlow():any{
  try {
    const data = yield call(fetchProvinces)
    if (data) {
      yield put(fetchProvincesActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchProvincesActionFail())
  }
}

function* fetchGetMarksFlow({ payload }:any):any{
  try {
    const data = yield call(getMarks, payload)
    if (data) {
      yield put(fetchGetMarksActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchGetMarksActionFail())
  }
}

function* fetchCreateAdmissionDocumentFlow({ payload }:any):any{
  try {
    const data = yield call(addDocument, payload)
    if (data) {
      yield put(fetchCreateAdmissionDocumentActionDone(data))
    }
  } catch (e) {
    console.error(e)
    yield put(fetchCreateAdmissionDocumentActionFail)
  }
}

function* checkIinFlow({ payload }:any):any{
  try {
    const data = yield call(checkIIN, payload)
    if (data.data.data.checkIin) {
      yield put(fetchCheckIinActionDone(data))
    } else {
      message.error(data.data.errors[0].debugMessage)
      yield put(fetchCheckIinActionFail())
    }
  } catch (e) {
    console.warn(e);
    yield put(fetchCheckIinActionFail())
  }
}

function* checkEmailFlow({ payload }:any):any{
  try {
    const data = yield call(checkEmail, payload)
    if (data.data.data.checkEmail) {
      yield put(fetchCheckEmailActionDone(data))
    } else {
      message.error("Указанный email уже используется!")
      yield put(fetchCheckEmailActionFail())
    }
  } catch (e) {
    console.warn(e);
    yield put(fetchCheckEmailActionFail())
  }
}

function* fetchLanguagesForSpecialitiesFormFlow():any{
  try {
    const data = yield call(fetchLanguagesForSpecialitiesForm)
    if (data) {
      yield put(fetchLanguagesForSpecialitiesFormActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchLanguagesForSpecialitiesFormActionFail())
  }
}

function* fetchAddLessonProfileFlow({payload}:any):any {
  try {
    const data = yield call(addLessonProfile, payload)
    if (data) {
      yield put(fetchAddLessonProfileActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchAddLessonProfileActionFail())
  }
}

function* fetchAddLessonNewProfileFlow({payload}:any):any {
  try {
    const data = yield call(addLessonProfile, payload)
    if (data.data.data.addOrChangeCustomRating) {
      yield put(fetchAddLessonProfileNewActionDone(data.data.data.addOrChangeCustomRating))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchAddLessonProfileNewActionFail())
  }
}

function* fetchEditNewProfileLessonFlow({payload}:any):any {
  try {
    const data = yield call(editLesson, payload)
    if (data.data.data.addOrChangeCustomRating) {
      yield put(fetchEditNewProfileLessonActionDone(data.data.data.addOrChangeCustomRating))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchEditNewProfileLessonActionFail())
  }
}

function* fetchDeleteProfileNewLessonFlow({payload}:any):any {
  try {
    const data = yield call(deleteLesson, payload)
    if (data.data.data.deleteCustomRating) {
      yield put(fetchDeleteProfileNewLessonActionDone(data.data.data.deleteCustomRating))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchDeleteProfileNewLessonActionFail())
  }
}

function* educationDocumentRatingFlow({payload}:any):any {
  try{
    const data = yield call(educationDocumentRating, payload)
    if(data.data.data.createOrUpdateEducationDocumentRating){
      yield put(educationDocumentRatingActionDone(data.data.data.createOrUpdateEducationDocumentRating))
    } else {
      message.error({ content: data.data.errors[0].debugMessage, style: {
          marginTop: '50vh'
        } })
      yield put(educationDocumentRatingActionFail())
    }
  } catch(e){
    console.warn(e);
    yield put(educationDocumentRatingActionFail())
  }
}

function* fetchEditLesson({payload}:any):any {
  try {
    const data = yield call(editLesson, payload)
    if (data) {
      yield put(fetchEditLessonActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchEditLessonActionFail())
  }
}

function* fetchDeleteLesson({payload}:any):any {
  try {
    const data = yield call(deleteLesson, payload)
    if (data) {
      yield put(fetchDeleteLessonActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchDeleteLessonActionFail())
  }
}

function* fetchSetExamMarks({payload}:any):any {
  try {
    const data = yield call(editLesson, payload)
    if (data.data.data.addOrChangeCustomRating) {
      yield put(fetchSetExamMarkActionDone(data.data.data.addOrChangeCustomRating))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchSetExamMarkActionFail())
  }
}

function* fetchSetExamResult({payload}:any):any {
  try {
    const data = yield call(setExamResult, payload)
    if (data.data.data.changeSelectedSpeciality) {
      yield put(fetchSetExamResultActionDone(data.data.data.changeSelectedSpeciality))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchSetExamResultActionFail())
  }
}

function* fetchGetInfo({payload}:any):any {
  try {
    const data = yield call(getInfo, payload)
    if (data) {
      yield put(fetchGetInfoActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchGetInfoActionFail())
  }
}

function* fetchGroup():any {
  try {
    const data = yield call(fetchGroupList)
    if (data) {
      yield put(fetchGroupListActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchGroupListActionFail())
  }
}

function* fetchExamResultFlow({payload}:any):any {
  try {
    const data = yield call(fetchExamResult, payload)
    if (data) {
      yield put(fetchExamResultActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchExamResultActionFail())
  }
}

function* declineReasonFlow({payload}:any):any {
  try{
    const data = yield call(declineReason, payload)
    if(data){
      yield put(fetchDeclineReasonDone(data))
    }
  } catch(e){
    console.warn(e);
    yield put(fetchDeclineReasonFail())
  }
}

function* fetchTotalResult({payload}:any):any {
  try {
    const data = yield call(getTotalResult, payload)
    if (data) {
      yield put(fetchGetTotalResultActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchGetTotalResultActionFail())
  }
}

function* fetchSetStatus({payload}:any):any {
  try {
    const data = yield call(setStatus, payload)
    if (data) {
      yield put(fetchSetStatusActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchSetStatusActionFail())
  }
}

function* addToStudentListFlow({payload}:any):any {
  try{
    const data = yield call(addToStudentListApi, payload)
    if(data){
      yield put(fetchAddToStudentListDone(data))
    }
  } catch(e){
    console.warn(e);
    yield put(fetchAddToStudentListFail())
  }
}

function* getStudentIdByEducationOrderFlow({payload}:any):any {
  try{
    const data = yield call(getStudentIdByEducationOrder, payload)
    if(data.data.data.getStudentIdByEducationOrder){
      yield put(fetchGetStudentByEducationOrderDone(data.data))
    } else {
      message.error({ content: data.data.errors[0].debugMessage, style: {
          marginTop: '50vh'
        } })
      yield put(fetchGetStudentByEducationOrderFail())
    }
  } catch(e){
    console.warn(e);
    yield put(fetchGetStudentByEducationOrderFail())
  }
}

//order
function* fetchCreateOrderFlow({payload}:any):any {
  try{
    const data = yield call(orderCreateApi, payload)

    if(data.data.data.addUserOrder){
      yield call(fetchSetSpecialityStatus, {payload: {id: payload.currentAcceptedChildId, status: 27}})
      yield delay(1000)
      yield put(fetchOrderCreateDone(data.data.data.addUserOrder))
      // window.parent.redirectToList()
      message.success({ content: 'Успешно!', style: {
          marginTop: '50vh'
        } })
      window.location.replace(`${process.env.REACT_APP_FULLSTACK_URL}/education-order/work-by-selection-committee?EducationOrderSearch%5Bstatus%5D=27`)
      // payload.navigate(`${process.env.REACT_APP_FULLSTACK_URL}/education-order/work-by-selection-committee?EducationOrderSearch%5Bstatus%5D=27`, {replace: true})
    } else {
      message.error({ content: data.data.errors[0].debugMessage, style: {
          marginTop: '50vh'
        } })
      yield put(fetchOrderCreateFail())
    }
  } catch(e){
    console.warn(e);
    yield put(fetchOrderCreateFail())
  }
}

function* fetchAcademicLeaveStudentFlow({payload}:any):any {
  try{
    const data = yield call(leaveStudentApi, payload)
    if(data.data.data.academicLeaveStudent){
      yield put(fetchOrderLeaveStudentDone(data.data.data.academicLeaveStudent))
      message.success({ content: 'Успешно!', style: {
          marginTop: '50vh'
        } })

      const fullstackFunc = JSON.stringify({
        func: 'message',
        needToGoBack: true
      });
      window.parent.postMessage(fullstackFunc, '*');
    } else {
      message.error({ content: data.data.errors[0].debugMessage, style: {
          marginTop: '50vh'
        } })
      yield put(fetchOrderLeaveStudentFail())
    }
  } catch(e){
    console.warn(e);
    yield put(fetchOrderLeaveStudentFail())
  }
}

function* fetchEditOrderFlow({payload}:any):any {
  try{
    const data = yield call(orderEditApi, payload)
    if(data.data.data.changeUserOrder){
      yield put(fetchOrderEditDone(data))
      message.success({ content: 'Успешно!', style: {
          marginTop: '50vh'
        } })

      const fullstackFunc = JSON.stringify({
        func: 'message',
        needToGoBack: true
      });
      window.parent.postMessage(fullstackFunc, '*');

    } else {
      message.error({ content: data.data.errors[0].debugMessage, style: {
          marginTop: '50vh'
        } })
      yield put(fetchOrderEditFail())
    }
  } catch(e){
    console.warn(e);
    yield put(fetchOrderEditFail())
  }
}

function* fetchOrderViewFlow({payload}:any):any {
  try{
    const data = yield call(orderViewApi, payload)
    if(data.data.data.userOrder){
      yield put(fetchOrderViewDone(data.data.data.userOrder))
    }
  } catch(e){
    console.warn(e);
    yield put(fetchOrderViewFail())
  }
}

function* setExecutorEgovApplicationFlow({payload}:any):any {
  try{
    const data = yield call(setExecutorEgovApplication, payload)
    if(data){
      yield put(fetchExecutorEgovApplicationDone(data))
    }
  } catch(e){
    console.warn(e);
    yield put(fetchExecutorEgovApplicationFail())
  }
}

function* fetchSetSpecialityStatus({payload}:any):any {
  try {
    const data = yield call(setSpecialtyStatus, payload)
    if (data.data.data.changeSelectedSpecialityStatus) {
      yield put(fetchSetSpecialityStatusActionDone(data.data.data.changeSelectedSpecialityStatus))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchSetSpecialityStatusActionFail())
  }
}

function* fetchCollegeAndExecutorFlow({payload}:any):any {
  try {
    const data = yield call(fetchCollegeAndExecutor, payload)
    if (data) {
      yield put(fetchCollegeAndExecutorActionDone(data))
    }
  } catch (e) {
    console.warn(e)
    yield put(fetchCollegeAndExecutorActionFail())
  }
}

function* getEntrantApplicationsFlow():any{
  try {
    const data = yield call(getEntrantApplications)

    if(data){
      yield put(fetchEntrantApplicationsActionDone(data.data.data.getEducationOrdersForEntrant))
    }
  } catch (e){
    yield put(fetchEntrantApplicationsActionFail())
  }
}

function* fetchAdmissionLogFlow({payload}:any):any {
  try{
    const data = yield call(admissionLogApi, payload)
    if(data){
      yield put(fetchAdmissionLogDone(data))
    }
  } catch(e){
    console.warn(e);
    yield put(fetchAdmissionLogFail())
  }
}

//Общий конкурс приёмка

function* getGeneralContestSpecialitiesListFlow({payload}:any):any{
  try {
    const data = yield call(getGeneralContestSpecialitiesList, payload)

    if (data.data){
      yield put(fetchGeneralContestSpecialitiesListActionDone(data.data.data.getSpecialityList))
    }
  } catch (e){
    console.warn(e);
    yield put(fetchGeneralContestSpecialitiesListActionFail())
  }
}

function* getGeneralContestWithQuotesFlow({payload}:any):any{
  try {
    const data = yield call(getGeneralContestWithQuotesNew, payload)

    if(data.data){

      let list = ['invalid1and2', 'vov', 'village_soc_ek', 'faces_kaz_nac_without_rk', 'children_without_parent', 'village_rk', 'children_many', 'family_half', 'family_with_invalid']

      const byQuota = list.reduce((acc:any, key:any) => {
        const filteredItems = data.data.data.getRagingList.filter((item:any) => (item.quota === key) && (item.selectedSpeciality.entrant_response != 3));
        acc[key] = filteredItems;
        return acc;
      }, {});

      const common = data.data.data.getRagingList.filter((item:any) => !item.quota)

      yield put(fetchGeneralContestWithQuotesActionDone(byQuota))
      yield put(fetchGeneralContestActionDone(common))
    }
  } catch (e){
    console.warn(e);
    yield put(fetchGeneralContestWithQuotesActionFail())
  }
}

function* changeEntrantStatusFlow({payload}:any):any{
  try {
    const data = yield call(changeEntrantResponse, payload)

    if(data.data){
      yield put(editEntrantStatusActionDone(payload))
    }
  } catch (e){
    console.warn(e);
    yield put(editEntrantStatusActionFail())
  }
}

function* getCollegeListToTransferFlow({payload}:any):any{
  try {
    const data = yield call(getCollegeListToTransfer, payload)

    if(data.data){
      yield put(fetchCollegeListToTransferActionDone(data.data.data.getCollegeListTransfer))
    }
  } catch (e){
    console.warn(e);
    yield put(fetchCollegeListToTransferActionFail())
  }
}

function* getEntrantTransferToOtherCollegeFlow({payload}:any):any{
  try {
    const data = yield call(entrantTransferToOtherCollege, payload)

    if(data.data){
      yield put(fetchEntrantTransferToOtherCollegeActionDone(data.data.data))
    }
  } catch (e){
    yield put(fetchEntrantTransferToOtherCollegeActionFail())
  }
}

//entrant-info
function* getEntrantInfoFlow():any{
  try {
    const data = yield call(getEntrantInfoData)

    if(data.data){
      yield put(fetchEntrantInfoActionDone(data.data.data.listOfRating))
    }
  } catch (e){
    yield put(fetchEntrantInfoActionFail())
  }
}

//sign xml parent/entrant
function* getEducationOrderXMLFlow({payload}:any):any{
  try {
    const data = yield call(getEducationOrderXML, payload)

    if(data.data){
      yield put(fetchEducationOrderXMLActionDone(data.data))
    }
  } catch (e){
    yield put(fetchEducationOrderXMLActionFail())
  }
}

function* postEducationOrderXMLFlow({payload}:any):any{
  try {
    const data = yield call(postEducationOrderXML, payload)

    if(data.data){
      yield put(postEducationOrderXMLActionDone(data.data))
    }
  } catch (e){
    yield put(postEducationOrderXMLActionFail())
  }
}

export default function* admissionSaga(){
  yield takeLatest(createEducationOrderAction, createEducationOrderFlow);
  yield takeLatest(fetchEducationEditOrderAction, fetchChangeEducationOrderFlow);
  yield takeEvery(fetchDataForSpecialitiesFormAction, fetchDataForSpecialitiesFormV2Flow);
  yield takeLatest(fetchCollegesWithQualificationsAction, fetchCollegesWithQualificationsFlow);


  yield takeLatest(createSelectedSpecialityAction, createSelectedSpecialityFlow);
  yield takeLatest(deleteSelectedSpecialityAction, deleteSelectedSpecialityFlow);
  yield takeLatest(changeSelectedSpecialityPriorityAction, changeSelectedSpecialityPriorityFlow);

  yield takeLatest(fetchProvincesAction, fetchProvincesFlow);

  yield takeLatest(fetchGetMarksAction, fetchGetMarksFlow);

  yield takeLatest(fetchEditLessonAction, fetchEditLesson);
  yield takeLatest(fetchDeleteLessonAction, fetchDeleteLesson);
  yield takeLatest(fetchGetInfoAction, fetchGetInfo);
  yield takeLatest(fetchGetStudentByEducationOrder, getStudentIdByEducationOrderFlow);
  yield takeLatest(fetchGroupListAction, fetchGroup);
  yield takeLatest(fetchSetStatusAction, fetchSetStatus);
  yield takeLatest(fetchAddToStudentList, addToStudentListFlow);
  yield takeLatest(fetchOrderCreate, fetchCreateOrderFlow);
  yield takeLatest(fetchOrderLeaveStudent, fetchAcademicLeaveStudentFlow);
  yield takeLatest(fetchOrderEdit, fetchEditOrderFlow);
  yield takeLatest(fetchOrderView, fetchOrderViewFlow);
  yield takeLatest(fetchExecutorEgovApplication, setExecutorEgovApplicationFlow);
  yield takeLatest(fetchGetTotalResultAction, fetchTotalResult);
  yield takeLatest(fetchExamResultAction, fetchExamResultFlow);
  yield takeLatest(fetchDeclineReason, declineReasonFlow);
  yield takeLatest(fetchSetSpecialityStatusAction, fetchSetSpecialityStatus);
  yield takeLatest(fetchCollegeAndExecutorAction, fetchCollegeAndExecutorFlow);
  yield takeLatest(fetchSetExamResultAction, fetchSetExamResult);

  //общий конкурс
  yield takeLatest(fetchGeneralContestSpecialitiesListAction, getGeneralContestSpecialitiesListFlow)
  yield takeEvery(fetchGeneralContestWithQuotesAction, getGeneralContestWithQuotesFlow)
  yield takeLatest(editEntrantStatusAction, changeEntrantStatusFlow)
  yield takeLatest(fetchCollegeListToTransferAction, getCollegeListToTransferFlow)
  yield takeLatest(fetchEntrantTransferToOtherCollegeAction, getEntrantTransferToOtherCollegeFlow)

  //admission log
  yield takeLatest(fetchAdmissionLog, fetchAdmissionLogFlow);

  //admission entrant applications
  yield takeLatest(fetchEntrantApplicationsAction,getEntrantApplicationsFlow)

  //admission documents
  yield takeLatest(fetchCreateAdmissionDocumentAction, fetchCreateAdmissionDocumentFlow)

  //check iin
  yield takeLatest(fetchCheckIinAction, checkIinFlow);

  //check email
  yield takeLatest(fetchCheckEmailAction, checkEmailFlow);

  //languages
  yield takeLatest(fetchLanguagesForSpecialitiesFormAction, fetchLanguagesForSpecialitiesFormFlow);

  //marks
  yield takeLatest(fetchAddLessonProfileNewAction, fetchAddLessonNewProfileFlow);
  yield takeLatest(fetchDeleteProfileNewLessonAction, fetchDeleteProfileNewLessonFlow);
  yield takeLatest(fetchEditNewProfileLessonAction, fetchEditNewProfileLessonFlow);
  yield takeLatest(fetchAddLessonProfileAction, fetchAddLessonProfileFlow);
  yield takeEvery(educationDocumentRatingAction, educationDocumentRatingFlow);

  yield takeLatest(fetchSetExamMarkAction, fetchSetExamMarks);

  //entrant-info
  yield takeLatest(fetchEntrantInfoAction, getEntrantInfoFlow);

  //entrant-info
  yield takeLatest(fetchEducationOrderXMLAction, getEducationOrderXMLFlow);
  yield takeLatest(postEducationOrderXMLAction, postEducationOrderXMLFlow);
}
